// ChamadoDetalhes.js (Corrigido com ChatWindow e Tratamento de Erro)

import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { doc, getDoc } from './firestore-compat';
import { db, auth } from "./firebase";
import ChatWindow from "./ChatWindow";

function ChamadoDetalhes() {
    const { id } = useParams();
    const location = useLocation();
    const [chamado, setChamado] = useState(null);
    const [isTecnico, setIsTecnico] = useState(false);

    useEffect(() => {
        const carregar = async () => {
            try {
                const snap = await getDoc(doc(db, "chamados", id));
                if (snap.exists()) {
                    setChamado({ id: snap.id, ...snap.data() });
                } else {
                    setChamado(false);
                }
            } catch (error) {
                console.error("Erro ao carregar:", error);
                setChamado(false);
            }
        };
        carregar();
    }, [id]);

    useEffect(() => {
        if (chamado && auth.currentUser) {
            // Se o email logado for igual ao do solicitante, é o CLIENTE (isTecnico = false)
            // Caso contrário, assumimos que é um TÉCNICO/ADM visualizando (isTecnico = true)
            const isOwner = auth.currentUser.email === chamado.solicitanteEmail;
            setIsTecnico(!isOwner);
        }
    }, [chamado]);

    if (chamado === null) return <p className="msg-box msg-success">Carregando...</p>;
    if (chamado === false) return (
        <div className="chamado-detalhes-container">
            <p className="msg-box msg-error">Chamado não encontrado.</p>
            <Link to="/meus-chamados" className="btn-voltar">Voltar para Início</Link>
        </div>
    );

    // Lógica de Retorno Inteligente
    // Se veio do state (ex: MeusChamados), respeita. Se não, decide por Auth.
    const backLink = location.state?.from || (isTecnico ? "/painel-chamados" : "/meus-chamados");

    return (
        <div className="chamado-detalhes-container">

            <header className="detalhes-header">
                <Link to={backLink} className="btn-voltar">{"< Voltar"}</Link>
                <h2>Chamado #{chamado.idPublico}</h2>
            </header>

            <div className="detalhes-grid">
                <div className="detalhes-item">
                    <label>Título do Assunto</label>
                    <p>{chamado.title}</p>
                </div>
                <div className="detalhes-item">
                    <label>Categoria</label>
                    <p>{chamado.category}</p>
                </div>
                <div className="detalhes-item">
                    <label>Solicitante</label>
                    <p>{chamado.solicitanteNome}</p>
                    <small style={{ color: '#999' }}>{chamado.solicitanteEmail}</small>
                </div>
                <div className="detalhes-item">
                    <label>Status Atual</label>
                    <span className={`badge status-${chamado.status?.toLowerCase().replace(/\s/g, '-')}`}>
                        {chamado.status}
                    </span>
                </div>

                <div className="detalhes-item detalhes-full">
                    <label>Descrição Detalhada</label>
                    <p>{chamado.descricao || chamado.description}</p>
                </div>
            </div>

            {/* DADOS ADICIONAIS DE USUÁRIO */}
            {chamado.category === 'Criação de Usuário' && chamado.dadosNovoUsuario && (
                <div className="user-ficha">
                    <h3>👤 Ficha de Criação de Usuário</h3>
                    <div className="detalhes-grid" style={{ marginTop: '20px' }}>
                        <div className="detalhes-item">
                            <label>Nome Completo</label>
                            <p>{chamado.dadosNovoUsuario.nomeCompleto}</p>
                        </div>
                        <div className="detalhes-item">
                            <label>CPF</label>
                            <p>{chamado.dadosNovoUsuario.cpf}</p>
                        </div>
                        <div className="detalhes-item">
                            <label>Cargo / Função</label>
                            <p>{chamado.dadosNovoUsuario.cargo} - {chamado.dadosNovoUsuario.funcao}</p>
                        </div>
                        <div className="detalhes-item">
                            <label>Conselho</label>
                            <p>{chamado.dadosNovoUsuario.conselho || '-'} {chamado.dadosNovoUsuario.numConselho}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* ÁREA DE CHAT */}
            <div style={{ marginTop: '40px' }}>
                <ChatWindow
                    chamadoId={chamado.id}
                    isTecnico={isTecnico}
                    solicitanteNome={chamado.solicitanteNome}
                    assignedToName={chamado.assignedToName}
                />
            </div>
        </div>
    );
}

export default ChamadoDetalhes;